module.exports = __webpack_public_path__ + "static/media/tallinn-22.b9722532.jpg";